// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/LauncherOrgToolbar.test.tsx
import { useLayoutEffect, useRef, useState } from "react";

/** Collapse People/Tags/Sort/Save view below this available toolbar width. */
export const LAUNCHER_TOOLBAR_COMPACT_BELOW_PX = 720;
/** Re-expand only after the available width clears this gap (avoids flicker). */
export const LAUNCHER_TOOLBAR_EXPAND_ABOVE_PX = 800;

/**
 * Compact when the launcher toolbar's available width is too narrow for
 * labeled People / Tags / Sort / Save view controls.
 */
export function useCompactLauncherToolbar() {
  const ref = useRef<HTMLDivElement>(null);
  const [compact, setCompact] = useState(false);

  useLayoutEffect(() => {
    const node = ref.current;
    if (!node) return;

    const applyWidth = (raw: number) => {
      const width = Math.round(raw);
      // why: jsdom reports 0; stay wide so inline filter testids remain the default
      if (width <= 0) return;
      setCompact((prev) =>
        prev
          ? width < LAUNCHER_TOOLBAR_EXPAND_ABOVE_PX
          : width < LAUNCHER_TOOLBAR_COMPACT_BELOW_PX,
      );
    };

    applyWidth(node.getBoundingClientRect().width);

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (!entry) return;
      applyWidth(entry.contentRect.width);
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return { ref, compact };
}
